// @ts-nocheck
import * as packageTypeApi from '../api/packageTypeApi';
import actionTypes from '../constants/actionTypes';

export const savePackageType = (packageType) => async (dispatch) => {
  const response = await packageTypeApi.savePackageType(packageType);
  dispatch({
    type: packageType.id
      ? actionTypes.UPDATE_PACKAGETYPE
      : actionTypes.CREATE_PACKAGETYPE,
    packageType: { ...packageType, id: response.id },
  });
  return response;
};

export function getPackageTypeById(id) {
  return packageTypeApi.getPackageTypeById(id);
}

export function loadPackageTypes(params) {
  return packageTypeApi.getPackageTypes(params);
}

export function getStats(id) {
  return packageTypeApi.getStats(id);
}

export function getAudit(id) {
  return packageTypeApi.getAudit(id);
}

export function addAudit(id, comment) {
  return packageTypeApi.addAudit(id, comment);
}

export function getAllPackageTypes() {
  return function (dispatch) {
    return packageTypeApi.getAllPackageTypes().then((packageTypes) => {
      dispatch({
        type: actionTypes.LOAD_PACKAGETYPES,
        packageTypes,
      });
    });
  };
}

export function deletePackageType(id) {
  return function (dispatch) {
    return packageTypeApi.deletePackageType(id).then(() => {
      dispatch({
        type: actionTypes.DELETE_PACKAGETYPE,
        id,
      });
    });
  };
}

export function exportPackageTypeData(filters, scopes) {
  return packageTypeApi.exportPackageTypeData(filters, scopes);
}
